module.exports = __webpack_public_path__ + "img/progressCheck.f918de75.svg";